import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useMediaTypes } from 'sb-hooks'
import cx from 'classnames'
import { Grid, Cell } from 'components/_new/layout/grid'

import s from './Products.scss'


export const getOrderedItems = (items, injectItems = [], mediaTypes) => {

  const orderedItems = [...items]

  if (injectItems.length) {

    injectItems.forEach((item) => {
      // if item in injectItems has "order" we need to reorder "items"
      // if "order" is object with different media we generate array for current media type – descktop, mobile, etc.
      if (item.order && typeof item.order === 'object') {
        let order

        // get "order" for current media type
        Object.keys(item.order).some((media) => {
          if (mediaTypes[media]) {
            order = item.order[media]
            return true
          }

          return false
        })

        // if there is no order found for current screen we use first key value in "order" object
        if (!order) {
          const media = Object.keys(item.order)[0]

          order = item.order[media]
        }

        if (items.length >= order - 1) {
          orderedItems.splice(order - 1, 0, item)
        }
      }
      else if (item.order && items.length >= item.order - 1) {
        orderedItems.splice(item.order - 1, 0, item)
      }
      else {
        orderedItems.push(item)
      }
    })
  }

  return orderedItems
}

const Products = (props) => {
  const {
    children, className, columns = {}, gutter, items, injectItems = [], productClassName, lastItemNode,
  } = props
  const { mobile = 2, tabletPortrait = 2, tabletLandscape = 3, desktop = 4 } = columns

  const mediaTypes = useMediaTypes()

  const gridColumns = { mobile, tabletPortrait, tabletLandscape, desktop }
  let listItems     = null

  if (!items) {
    return null
  }

  if (items) {
    let orderedItems = getOrderedItems(items, injectItems, mediaTypes)

    listItems = orderedItems.map((item, index) => {
      // if item come from injectItems
      if (item.render) {
        return (
          <Cell key={item.id || index} size={item.size} className={s.product}>
            {item.render()}
          </Cell>
        )
      }

      // if item is Product
      return (
        <Cell key={item.id || index} className={cx(s.product, productClassName)}>
          {children(item)}
        </Cell>
      )
    })
  }

  // perfumesList class is needed for scrolling, because there can be multiple perfumes lists on the page
  return (
    <div
      data-testid="perfumesList"
      className={cx('perfumesList', s.products, className)}
    >
      <Grid columns={gridColumns} gutter={gutter}>
        {listItems}
        {lastItemNode}
      </Grid>
    </div>
  )
}

Products.propTypes = {
  children: PropTypes.func.isRequired,
  items: PropTypes.array,
  className: PropTypes.string,
  productClassName: PropTypes.string,
  columns: PropTypes.object,
  gutter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  injectItems: PropTypes.array,
}


export default memo(Products)
